const canUseDOM = !!(
  window !== undefined &&
  window.document &&
  window.document.createElement
);

export const executionEnvironment = {
  canUseDOM,
};
